<template>
  <b-card>
    <div>
      <div class="row">
        <b-form-group label="Location Type" label-for="location-type" class="col-lg-12">
          <b-select v-model="attraction._type" id="location-type" name="location-type" v-validate="{ required: true }"
            :state="validateState('attraction._type')">
            <option :value="null" selected>Select a Type</option>
            <option value="AmusementPark">Amusement Park</option>
            <option value="BotanicalGardens">Botanical Gardens</option>
            <option value="GolfCourse">Golf Course</option>
            <option value="HistoricSite">Historic Site</option>
            <option value="IndoorRecreationSite">Indoor Recreation Site</option>
            <option value="IndustryManufacturing">Industry &amp; Manufacturing</option>
            <option value="Museum">Museum</option>
            <option value="NationalPark">National Park</option>
            <option value="OtherPark">Other Park</option>
            <option value="OutdoorRecreationSite">Outdoor Recreation Site</option>
            <option value="ScienceCenter">Science Center</option>
            <option value="SportsFacility">Sports Facility</option>
            <option value="StatePark">State Park</option>
            <option value="ZoologicalPark">Zoological Park</option>
          </b-select>
          <div class="red"><font-awesome-icon v-if="veeErrors.first('location-type')" icon="exclamation-circle" size="1x"
              style="color:red;" class=" mr-1 fas fa-exclamation-circle" />{{ veeErrors.first('location-type') }}</div>
        </b-form-group>
      </div>

      <div class="row">
        <b-form-group label="Is an admission charged?" label-for="cost" class="col-lg-3">
          <b-form-checkbox id="cost" name="cost" v-model="attraction.cost" @change="onChange" switch />
        </b-form-group>

        <b-form-group label="Fees" label-for="fee" class="col-lg-3" v-if="attraction.cost">
          <b-form-input id="fees" name="fees" v-model="attraction.fees" @change="onChange" />
        </b-form-group>

        <TelephoneInput label="Telephone" id="phone" name="phone" v-model="attraction.phone" @input="dirty = true"
          @change="onChange" />
        <!-- <b-form-group label="Telephone" label-for="phone" class="phone-group col-lg-3">
            <b-form-input type="tel" id="phone" name="phone" v-mask="'(###) ###-####'" @input="dirty = true"
              v-model="attraction.phone" @change="onChange" class="phone-group col-lg-3" />
          </b-form-group> -->

        <b-form-group label="Hours Of Operation" label-for="hoursOfOperation" class="col-lg-3">
          <b-form-input id="hours" name="hours" v-model="attraction.hoursOfOperation" @change="onChange"
            v-validate="{ required: true }" :state="validateState('attraction.hoursOfOperation')" />
          <div class="red"><font-awesome-icon v-if="veeErrors.first('hours')" icon="exclamation-circle" size="1x"
              style="color:red;" class=" mr-1 fas fa-exclamation-circle" />{{ veeErrors.first('hours') }}</div>
        </b-form-group>
      </div>

      <div class="row mb-3" v-if="attraction.cost">
        <div class="col-lg-12">
          <b-form-group label="Discounts" class="">
            <b-card>
              <b-form-checkbox-group id="discounts" name="Discounts" v-model="attraction.discounts"
                style="column-count: 2;" stacked>
                <b-form-checkbox value="AAA">AAA</b-form-checkbox>
                <b-form-checkbox value="Government">Government</b-form-checkbox>
                <b-form-checkbox value="Military">Military</b-form-checkbox>
                <b-form-checkbox value="Senior">Senior</b-form-checkbox>
              </b-form-checkbox-group>
            </b-card>
          </b-form-group>
        </div>
      </div>

      <div class="row" v-if="attraction.cost">
        <div class="col-lg-12">
          <b-form-group label="Credit Cards Accepted" label-for="creditCards col-lg-12">
            <credit-cards :value="attraction.creditCards" v-model="attraction.creditCards" @change="onChange" />
          </b-form-group>
        </div>
      </div>

    </div>
  </b-card>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import creditCards from '../../../components/CreditCards.vue';
import TelephoneInput from '../../../components/TelephoneInput.vue';

export default {
  components: {
    creditCards,
    TelephoneInput,
  },
  data() {
    return {
      attraction: {
        fees: '',
        cost: false,
        hoursOfOperation: {},
        discounts: '',
        creditCards: [],
        phone: '',
      },
      submitted: false,
    };
  },
  props: ['value'],
  validations: {
    attraction: {
      hoursOfOperation: {
        required,
      },
    },
  },
  mounted() {
    this.attraction = this.value;
    this.attraction.phone = this.value.phone;
  },
  methods: {
    onChange() {
      this.$emit('input', this.attraction);
      this.$emit('change', this.attraction);
    },
    validate() {
      this.submitted = true;
      this.$v.$touch();
      return !this.$v.$invalid;
    },
    validateState(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
  },
};
</script>

<style>
.phone-group,
.discounts-group {
  width: 300px;
}
</style>
